import { textToSlug } from './slugUtils';
/**
 * Convierte un nombre de producto a formato URL-friendly
 * @param {string} productName - Nombre del producto
 * @returns {string} - Nombre del producto en formato URL-friendly
 */
export const createProductSlug = (productName) => {
    if (!productName) return '';
    
    return productName
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '') // Remover caracteres especiales excepto espacios y guiones
        .replace(/\s+/g, '-') // Reemplazar espacios con guiones
        .replace(/-+/g, '-') // Reemplazar múltiples guiones con uno solo
        .replace(/^-|-$/g, ''); // Remover guiones al inicio y final
};

/**
 * Genera una URL amigable para un producto
 * @param {number|string} productId - ID del producto
 * @param {string} productName - Nombre del producto
 * @returns {string} - URL amigable del producto
 */
export const createProductUrl = (productId, productName) => {
    const slug = createProductSlug(productName);
    return `/producto/${productId}/${slug}`;
};

/**
 * Extrae el ID del producto de una URL amigable
 * @param {string} url - URL del producto
 * @returns {string|null} - ID del producto o null si no se encuentra
 */
export const extractProductIdFromUrl = (url) => {
    const match = url.match(/\/producto\/(\d+)/);
    return match ? match[1] : null;
};

/**
 * Navega al catálogo aplicando un filtro de texto (slug) y recarga la página.
 * Pensado para búsquedas iniciadas fuera de /catalogo.
 * @param {string} term - Texto libre de búsqueda
 */
export const navigateToCatalogWithFilter = (term) => {
    const cleaned = (term || '').trim();
    const slug = textToSlug(cleaned);
    if (!slug) return;
    const url = `/catalogo?filtro=${encodeURIComponent(slug)}`;
    window.location.assign(url);
};